/* prettier-ignore */

import { Component, computed, HostListener, inject, NgZone, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RestService } from 'src/app/services/rest.service';
import { ToolsService } from '../../services/tools.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NewCustomRouteService } from 'src/app/pages/new-custom-route/new-custom-route.service';
import { CookieService } from 'ngx-cookie-service';
import { MatDialogService } from 'src/app/services/mat-dialog.service';
import { MatBottomSheetService } from 'src/app/services/mat-bottom-sheet.service';
import { StandardDialog } from '../dialogs';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class HeaderComponent {
  private cookieService = inject(CookieService)
  private routeService = inject(NewCustomRouteService);
  private _matDialogService = inject(MatDialogService);
  private _matBottomSheet = inject(MatBottomSheetService);
  private _ngZone = inject(NgZone);
  
  public disableTouch = computed(() => this.routeService.disableTouch());
  //public isInfoRoutePage = computed(() => this.tools.isInfoRoutePage());
  public languages = computed( () => this.tools.languages());
  public logo: any;
  public currentClientId: any;

  @HostListener('document:click', ['$event'])
  hideModalOnClick(_event: MouseEvent) {
      if (!this.tools.menuIsShown) return;
      this.tools.menuIsShown = false;
  }

  constructor(
      private router: Router, 
      public translate: TranslateService, 
      public rest: RestService, 
      public tools: ToolsService, 
      public navigation: NavigationService
  ) {
      this.logo = this.rest?.device?.logo?.value;
      this.currentClientId = this.rest?.device?.client;
  }

  goToHome(): void{
    if (this.tools.isTechEditMode() || this.tools.isRegisterMode()) return;
    
    if (this.tools.isRoutePage('/custom-route')) {
      this.openConfirmationGoBackDialog();
      return;
    } else {
      this.router.navigateByUrl('/home');
    }
  }

  goBack(){
    if(this.isBackDistributor()){
        this.goDistributor();
        return;
    }

    if (this.tools.isRoutePage('/custom-route')) {
      this._matDialogService.closeAllMatDialogs();
      this._matBottomSheet.closeAllMatBottomSheets();
      
      /**
       * A setTimeout is neeeded to clean the dialogs and bottom sheets before the
       * goBack dialog appears. Otherwise the dialog is positioned incorrectly.
       */
      this._ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this._ngZone.run(() => {
            this.openConfirmationGoBackDialog();
          });
        }, 400);
      });
      return;
    } else if (this.tools.isRoutePage('not-found')) {
      this.navigation.resetNavigation();
    } else {
      this.navigation.goBack();
    }
  }

  goDistributor(){
      if (this.tools.isPreProduction()){
          const splitUrl = this.tools.homeDistributor?.split('.');
          const splitHttp = splitUrl?.[0].split('//');
          const nameIndex = splitHttp?.[splitHttp?.length - 1]?.trim();
          this.cookieService.set('preProduction', nameIndex)
          window.location.assign(`${window.location.origin}`)
          return;
      }
      window.location.assign(this.tools.homeDistributor);
  }

  showBackButton(){
      return !this.router.url.includes('/home') && !this.tools.isTechEditMode()
  }

  isBackDistributor(){
      return this.tools.homeDistributor && this.router.url.includes('/home')
  }
  
  openConfirmationGoBackDialog(): void {
    const dialogRef = this._matDialogService.openMatDialog({
      component: StandardDialog,
      data: {
        title: '¿' + this.translate.instant('Quieres volver atrás') + '?',
        content: this.translate.instant('Si regresas, perderás todos los cambios que hiciste en tu ruta. ¿Seguro que deseas continuar?'),
        primaryActionButtonText: this.translate.instant('Sí, volver'),
        secondaryActionButtonText: this.translate.instant('No, seguir aquí'),
        handleClickPrimaryButton: () => {
          this._matDialogService.closeAllMatDialogs();
          this.router.navigateByUrl('/home');
        },
        handleClickSecondaryButton: () => {
          this._matDialogService.closeMatDialog(dialogRef);
        }
      }
    });
  }
}